import { css } from '@microsoft/fast-element';
import { mixinScreen } from '../../styles';

export const ExecutionStyles = css`
  :host {
    ${mixinScreen('flex')}

    flex-direction: column;
    align-items: center;
  }

  .header {
    margin-top: 20px;
  }

  .header h2 {
    display: flex;
    width: 100%;
    color: var(--white-smoke);
    align-items: center;
    justify-content: center;
    margin-top: 0;
  }

  .with-bottom-margin {
    margin-bottom: 55px;
  }
`;
